/* WC — Multi-column: keep horizontal scroll, stop wheel hijack */
(() => {
  const GRID_SEL = '.multi-column__grid';

  function onWheel(e) {
    const grid = e.target.closest(GRID_SEL);
    if (!grid) return;

    // SHIFT+wheel maradhat "power user" horizontal
    if (e.shiftKey) return;

    const ax = Math.abs(e.deltaX || 0);
    const ay = Math.abs(e.deltaY || 0);

    // Ha a user tényleg oldalra gesztikulál (trackpad), hagyjuk
    if (ax > ay) return;

    // Vertikális intent → görgesse a page-et, ne a slidert
    e.preventDefault();
    e.stopPropagation();

    window.scrollBy({ top: e.deltaY, left: 0, behavior: 'auto' });
  }

  document.addEventListener('wheel', onWheel, { capture: true, passive: false });
})();